// extracted by mini-css-extract-plugin
module.exports = {"root":"BmiRanges_root___t33z","ranges":"BmiRanges_ranges__2FoKM"};